import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './Components/App';
import './gileadeGlobalConfig'

ReactDOM.render(<App />, document.getElementById('gileadeMapa'));



// WEBPACK FOOTER //
// ./src/index.js